module.exports = __webpack_public_path__ + "media/images/admiration_mark-2894d5eb.svg";